import React, { useContext } from 'react';
import './CandlestickTileValues.scss';
import { CandlestickTileData } from 'widgets/candlestickTile/candlestickTileData';
import AppContext from 'app/AppContext';
import { getBucketAtTime } from 'utils/timeseries/bucket';
import { applyTickSize } from 'utils/tickSize';

export interface CandlestickTileValuesProps {
    data: CandlestickTileData;
    time?: number;
    onClick: () => void;
}

export function CandlestickTileValues(props: CandlestickTileValuesProps) {
    const { onClick, data, time } = props;

    const { numberFormat, timeFormat } = useContext(AppContext);

    const bucket = getBucketAtTime(data?.timeSeries, time);
    const { tickSize } = data;

    if (!bucket) {
        return <div className="CandlestickTileValues" />;
    }

    const bucketTime = bucket
        ? `${timeFormat.toTimeMinutes(
              bucket.startTime
          )} - ${timeFormat.toTimeMinutes(bucket.endTime)}`
        : undefined;

    return (
        <div className="CandlestickTileValues flippable" onClick={onClick}>
            <div className="bucket-time">{bucketTime}</div>
            <div className="capsule-values">
                <div>
                    <div className="label">High</div>
                    <div className="value high-value">
                        {applyTickSize(numberFormat, tickSize, bucket.high)}
                    </div>
                    <div className="label">Low</div>
                    <div className="value low-value">
                        {applyTickSize(numberFormat, tickSize, bucket.low)}
                    </div>
                </div>
                <div>
                    <div className="label">Open</div>
                    <div className="value">
                        {applyTickSize(numberFormat, tickSize, bucket.open)}
                    </div>
                    <div className="label">Close</div>
                    <div className="value">
                        {applyTickSize(numberFormat, tickSize, bucket.close)}
                    </div>
                </div>
            </div>
        </div>
    );
}
